'use client';

import { FC, useEffect } from 'react';
import { shallow } from 'zustand/shallow';

import { liveChatStore } from '@/stores/liveChatStore';

export const ChatStoreHandler: FC = () => {
  const { visibility, setLiveChatVisibility, user } = liveChatStore(
    ({ visibility, setLiveChatVisibility, user }) => ({
      visibility,
      setLiveChatVisibility,
      user,
    }),
    shallow,
  );

  useEffect(() => {
    if (visibility !== 'hidden') {
      globalThis.window.LiveChatWidget?.init();
    }

    globalThis.window.LiveChatWidget?.call(getVisibility(visibility));
  }, [visibility]);

  useEffect(() => {
    if (user) {
      globalThis.window.LiveChatWidget?.call('set_customer_name', user.name);
      globalThis.window.LiveChatWidget?.call('set_customer_email', user.email);
    }
  }, [user]);

  useEffect(() => {
    const handleVisibilityChange = (data: { visibility: 'minimized' | 'maximized' | 'hidden' }) => {
      setLiveChatVisibility(data.visibility);
    };

    globalThis.window.LiveChatWidget?.on('visibility_changed', handleVisibilityChange);

    return () => {
      globalThis.window.LiveChatWidget?.off('visibility_changed', handleVisibilityChange);
    };
  }, [setLiveChatVisibility]);

  return null;
};

const getVisibility = (visibility?: string) => {
  switch (visibility) {
    case 'hidden':
      return 'hide';
    case 'minimized':
      return 'minimize';
    case 'maximized':
      return 'maximize';
    default:
      return 'hide';
  }
};
